'use client'

import cx from 'classnames'
import { useEffect, useState, type ReactNode } from 'react'

import GlobalSnackbar from 'containers/GlobalSnackbar'
import SmoothscrollLoader from 'containers/SmoothscrollLoader'
import ZendeskChat from 'containers/ZendeskChat'
import useGetABTestingFlagForQuickPurchase from 'hooks/useGetABTestingFlagForQuickPurchase'

import Header from './Header'
import Menu from './Menu'
import classes from './styles.module.scss'

export { default as Loader } from 'components/Loader'
export { default as Footer } from './Footer'

type Props = {
  children: ReactNode
  collapseCurrency?: boolean
  collapseMenu?: boolean
  hideSearchBar?: boolean
  isMobile?: boolean
  isDarkMode?: boolean
}

export default function LayoutClient(props: Props) {
  const [menuHidden, setMenuHidden] = useState<undefined | boolean>(props.collapseMenu)
  useGetABTestingFlagForQuickPurchase()
  const toggleMenu = () => setMenuHidden(!menuHidden)

  useEffect(() => {
    setMenuHidden(props.collapseMenu)
  }, [props.collapseMenu])

  return (
    <>
      <Header
        isMobile={props.isMobile}
        isDarkMode={props.isDarkMode}
        hideSearchBar={props.hideSearchBar}
        collapseCurrency={props.collapseCurrency}
      />

      <Menu
        isMobile={props.isMobile}
        menuHidden={menuHidden}
        triggerHidden={!props.collapseMenu}
        toggleMenu={toggleMenu}
      />

      <div className={cx(classes.content, menuHidden && classes['content--full'])}>{props.children}</div>

      <ZendeskChat />
      <GlobalSnackbar />
      <SmoothscrollLoader />
    </>
  )
}
